import gmailApi from './modules/store'

export const modules = {
  gmailApi
}



// WEBPACK FOOTER //
// ./src/store/Gapi/index.js